import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPurchasedPackages } from "@/services/student/packages.service";
import {
  getMySubscriptions,
  SubscriptionMine,
} from "@/services/student/subscriptions.api";

/**
 * Same clock as Meus Pacotes **Renovar**: only when a purchased card is
 * invalid now. PastDue leftovers without that card must not nag.
 */
export const SubscriptionPastDueBanner = () => {
  const [pastDue, setPastDue] = useState<SubscriptionMine | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const [purchased, list] = await Promise.all([
          getPurchasedPackages(),
          getMySubscriptions(),
        ]);
        if (cancelled) return;
        const renewableIds = new Set(
          purchased.filter((pkg) => pkg.isValidNow === false).map((pkg) => pkg.id)
        );
        if (renewableIds.size === 0) {
          setPastDue(null);
          return;
        }
        setPastDue(
          list.find(
            (s) => s.status === "PastDue" && renewableIds.has(s.packageId)
          ) ?? null
        );
      } catch {
        // Silent — banner is best-effort
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!pastDue) return null;

  return (
    <div
      role="status"
      className="mx-4 mt-4 rounded-lg border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-foreground flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
    >
      <p>
        Não conseguimos renovar{" "}
        <strong>{pastDue.packageName || "sua assinatura"}</strong>. Atualize o
        cartão para manter o acesso após o período de tolerância.
      </p>
      <Link
        to="/student/subscriptions"
        className="shrink-0 font-medium underline underline-offset-2 hover:text-foreground/80"
      >
        Gerenciar assinatura
      </Link>
    </div>
  );
};
